import ApiKeyDetails from './ApiKeyDetails';

export default ApiKeyDetails;